import request from '@/utils/request'

export async function loadSettings(params) {
  try {
    let response = await request({
      url: '/api/settings',
      method: 'get',
      params
    })
    return response.data.items[0]
  } catch (error) {
    throw error
  }
}

export function saveSettings(id, data) {
  return request({
    url: `/api/settings/${id}`,
    method: 'put',
    data
  })
}

export function loadCurrencies(params) {
  return request({
    url: '/api/currencies',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/modules/settings/api.js